import { nsContract, nsNotifRules } from '@/app/i18n/namespaces';
import APPLICATIONS from '../../contracts/enums/ItpRegex';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    CONTRACT: {
        key: 'contract',
        type: 'tel',
        entity: 'keys.contract',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.contract',
        filter: 'input',
        enableSorting: true
    },
    BANK_CODE: {
        key: 'bankCode',
        type: 'tel',
        entity: 'keys.bank_code',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.bank_code',
        filter: 'input',
        enableSorting: true
    },
    RANK: {
        key: 'rank',
        type: 'text',
        entity: 'keys.rank',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.rank',
        filter: 'input',
        enableSorting: true
    },
    RECIPIENT: {
        key: 'recipient',
        type: 'text',
        entity: 'keys.recipient',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.recipient',
        filter: 'input',
        enableSorting: true
    },
    PARTNER: {
        key: 'partner',
        type: 'text',
        entity: 'keys.partner',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.partner',
        filter: 'input',
        enableSorting: true
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: 'text',
        entity: 'keys.legal_name',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.legal_name',
        filter: 'input',
        enableSorting: true
    },
    EVENT_TYPE: {
        key: 'eventType',
        type: 'text',
        entity: 'push_payments_notif_rules',
        namespace: nsNotifRules
    },
    APPLICATION: {
        key: 'application',
        type: 'select',
        entity: 'keys.application',
        prefix: 'posTerminalApplication_',
        namespace: nsContract,
        filter: 'select',
        enum: APPLICATIONS,
        enableSorting: true,
        sortOptions: true
    },
    EXTRA_1: {
        key: 'extra1',
        type: 'text',
        entity: 'keys.extra_1',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.extra_1',
        filter: 'input',
        enableSorting: true
    },
    EXTRA_2: {
        key: 'extra2',
        type: 'text',
        entity: 'keys.extra_2',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.extra_2',
        filter: 'input',
        enableSorting: true
    },
    LABEL: {
        key: 'label',
        type: 'text',
        entity: 'keys.label',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.label',
        filter: 'input',
        enableSorting: true
    },
    // handle errors upload files
    RULES_NOT_PROCESSED: {
        key: 'notProcessedRules',
        type: 'array',
        CONTRACT: {
            parentKeys: ['notProcessedRules'],
            key: 'contract',
            type: 'tel',
            namespace: nsNotifRules,
            entity: 'keys.contract'
        },
        BANK_CODE: {
            parentKeys: ['notProcessedRules'],
            key: 'bankCode',
            type: 'tel',
            namespace: nsNotifRules,
            entity: 'keys.bank_code'
        },
        RANK: {
            parentKeys: ['notProcessedRules'],
            key: 'rank',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.rank'
        },
        RECIPIENT: {
            parentKeys: ['notProcessedRules'],
            key: 'recipient',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.recipient'
        },
        PARTNER: {
            parentKeys: ['notProcessedRules'],
            key: 'partner',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.partner'
        },
        LEGAL_NAME: {
            parentKeys: ['notProcessedRules'],
            key: 'legalName',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.legal_name'
        },
        EVENT_TYPE: {
            parentKeys: ['notProcessedRules'],
            key: 'eventType',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'push_payments_notif_rules'
        },
        APPLICATION: {
            parentKeys: ['notProcessedRules'],
            key: 'application',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.application'
        },
        EXTRA_1: {
            parentKeys: ['notProcessedRules'],
            key: 'extra1',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.extra_1'
        },
        EXTRA_2: {
            parentKeys: ['notProcessedRules'],
            key: 'extra2',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.extra_2'
        },
        LABEL: {
            parentKeys: ['notProcessedRules'],
            key: 'label',
            type: 'text',
            namespace: nsNotifRules,
            entity: 'keys.label'
        }
    }
};